const { gtag } = window;

export default gtag;
